import styled from "styled-components";

import { buttonBaseMixin, sizeButtonMixin } from "uikit/Button/styles";
import { IInputButtonSize } from "uikit/types";

export const AssistantButton = styled.button<{ $size: IInputButtonSize }>`
  ${buttonBaseMixin};
  ${sizeButtonMixin};
  background-color: ${({ theme }) => theme.colors.colorsNew.base.white};
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
  border-radius: 200px;
  box-shadow: 0px 4px 14px 0px ${({ theme }) => theme.colors.colorsNew.green.green}17;

  &:hover {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray[100]};
  }

  span {
    background: ${({ theme }) => theme.colors.colorsNew.gradient.green};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
  }
`;
